import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
	providedIn: 'root'
})
export class FileSaverService {

	constructor(@Inject(PLATFORM_ID) private platformId: any) {
	}

	private get isBrowser(): boolean {
		return isPlatformBrowser(this.platformId);
	}

	saveFile(blob, filename): void {
		if (!this.isBrowser)
			return;

		if (window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveOrOpenBlob(blob, filename);
		} else {
			const a = document.createElement('a');
			document.body.appendChild(a);
			const url = window.URL.createObjectURL(blob);
			a.href = url;
			a.download = filename;
			a.click();
			setTimeout(() => {
				window.URL.revokeObjectURL(url);
				document.body.removeChild(a);
			}, 0);
		}
	}
}
